// @util/gearsync/api/useEbayWithdraw.ts
// Per-listing "Remove from eBay" action.

export type WithdrawResult = {
  id: string;
  status: 'withdrawn' | 'no-listing' | 'error';
  method?: 'withdrawOffer' | 'endFixedPriceItem';
  error?: string;
};

/**
 * End the given GearFocus-direct listings on eBay. Server-side enforces
 * ownership and the gearfocus-direct source gate so we can never end a
 * Lightspeed-published listing through here.
 */
export async function withdrawFromEbay(
  productIds: string[]
): Promise<WithdrawResult[]> {
  const res = await fetch('/api/gearsync/ebay/withdraw', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ productIds }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || 'Failed to remove from eBay');
  }
  return Array.isArray(data?.results) ? data.results : [];
}
